import moment from 'moment'
import React from 'react'
import { Link } from 'navigation'
import { editIcon } from '../../../assets/assets'
import {
  canEditCompletedInstrument,
  extractCompletedInstanceQuestions,
  getCompletedEntryForReview,
  saveInstrumentToLocalStorage
} from '../utils/instrumentUtils'
import { UNTITLED_INSTRUMENT } from '../../../utils/constants'
import { resolveInstrumentWebSurveyPath } from '../../WebSurveys/utils/webSurveyUrl'

export const buildCompletedInstrumentUrl = (args = {}) =>
  resolveInstrumentWebSurveyPath(args, args)

const parseLocalizedTitle = ({ selectedLocale, instrument }) => {
  const { instrument_title, title, displayNameTranslations } = instrument

  const baseTitle = instrument_title || title

  if (!displayNameTranslations) return baseTitle

  const formattedSelectedLocale = selectedLocale?.toLowerCase() || 'en'

  const localizedDisplayName = displayNameTranslations[formattedSelectedLocale]

  if (localizedDisplayName) return localizedDisplayName

  const locale = formattedSelectedLocale.includes('_')
    ? formattedSelectedLocale.split('_')[0]
    : formattedSelectedLocale

  return displayNameTranslations[locale] || baseTitle
}

const CompletedInstrumentsListItem = ({
  completedInstrument,
  studyId,
  participantId,
  setSubmissionSurvey,
  formatSubmissionSurvey,
  selectedLocale
}) => {
  const instance = completedInstrument?.instances.find(
    item => !!item?.completion
  )

  const getStatus = () => {
    return 'Complete'
  }

  const canEdit = canEditCompletedInstrument(completedInstrument)
  const {
    instrument_type: type,
    instrument_id,
    metadata = {}
  } = completedInstrument

  // Get instrument title with localization support and fallbacks
  // Try multiple possible sources for the title
  const possibleTitle =
    completedInstrument.instrument_title ||
    completedInstrument.title ||
    metadata?.display_name ||
    completedInstrument.display_name ||
    UNTITLED_INSTRUMENT

  const instrumentTitle = parseLocalizedTitle({
    selectedLocale,
    instrument: {
      ...completedInstrument,
      instrument_title: possibleTitle,
      title: possibleTitle
    }
  }) || possibleTitle

  const instrumentIdResolved =
    instrument_id || completedInstrument.identity || completedInstrument.id

  const submissionSurvey = formatSubmissionSurvey
    ? formatSubmissionSurvey(completedInstrument)
    : null

  const handleClick = e => {
    if (!(canEdit && setSubmissionSurvey && submissionSurvey && participantId)) return
    e.stopPropagation()

    const snapshot = getCompletedEntryForReview({
      participantId,
      instrumentId: instrumentIdResolved,
      instanceId: instance?.instance_id
    })
    const fromApi = extractCompletedInstanceQuestions(completedInstrument)
    const questions =
      snapshot?.questions?.length > 0
        ? snapshot.questions
        : fromApi.length > 0
          ? fromApi
          : submissionSurvey.questions || []

    const payload = {
      ...submissionSurvey,
      questions,
      last_updated: snapshot?.last_updated || instance?.completion,
      instance_id: instance?.instance_id,
      identity: instrumentIdResolved,
      instrument_id: instrumentIdResolved,
      __reviewCompletedEntry: true
    }

    saveInstrumentToLocalStorage({
      instrumentId: instrumentIdResolved,
      participantId,
      instrument: payload
    })
    setSubmissionSurvey(payload)
  }

  const content = (
    <div className='completed-instrument'>
      <div className='completed-instrument-top-section'>
        <span className='completed-instrument-recorded-text'>
          {`Recorded ${moment(instance?.completion).format(
            'DD/MM/YYYY, hh:mm A'
          )}`}
        </span>
        {canEdit && (
          <div className='completed-instrument-top-actions'>
            <div className='completed-instrument-edit-icon'>
              {editIcon()}
            </div>
            <i className='fa fa-chevron-right completed-instrument-chevron' />
          </div>
        )}
      </div>
      <div className='completed-instrument-main-section'>
        <div className='completed-instrument-status'>{getStatus()}</div>
        <div className='completed-instrument-title' style={{ color: '#000000', fontSize: '23px', fontWeight: '700' }}>
          {instrumentTitle}
        </div>
      </div>
    </div>
  )

  if (canEdit && studyId && instrument_id && type) {
    return (
      <Link
        to={resolveInstrumentWebSurveyPath(completedInstrument, {
          studyId,
        })}
        onClick={handleClick}>
        {content}
      </Link>
    )
  }

  return content
}

export default CompletedInstrumentsListItem
